(function () {

  angular
    .module('meanApp')
    .directive('userThumb', userThumb);

  function userThumb () {
    return {
      restrict: 'E',
      scope : {
        'user': '=',
        'size' : '@'
      },
      templateUrl: '/common/directives/userthumb/userthumb.template.html'
    };
  }

})();